import React from 'react';
import styled from 'styled-components';
import Img from 'gatsby-image';

const Figure = ({ slice }) => {
    const image = {
        src: slice.imageSharp.childImageSharp.fluid,
        alt: slice.image.alt
    };

    return (
        <SFigure>
            {/* <Image alt="Placeholder People Card" filename="placeholders/placeholder-copy-image-3.jpg" /> */}
            <Img alt={image.alt} fluid={image.src} />
            <figcaption>{slice.caption}</figcaption>
        </SFigure>
    );
};

const SFigure = styled.figure`
    * + &,
    & + * {
        margin-top: 60px !important;
    }

    & + & {
        margin-top: 20px;
    }

    figcaption {
        margin-top: 6px;
    }
`;

export default Figure;
